
import {authorize, authorize_onboarding} from "../helper/authorize-token";
import superagent from 'superagent';
import { sprintf } from "sprintf-js";
import {deep_copy, deep_update} from "../../lib/js-utils";

const DWOLLA_UPDATE = "DWOLLA_UPDATE";
const DWOLLA_SET_LOADING = "DWOLLA_SET_LOADING";
const DWOLLA_VERIFY_CUSTOMER = "DWOLLA_VERIFY_CUSTOMER";
const REFRESH_DWOLLA = "REFRESH_DWOLLA";
const DWOLLA_CLEAR = "DWOLLA_CLEAR";

const dwollaUpdate = (data, index, username) => {
  return dispatch => {
    dispatch({
      type: DWOLLA_UPDATE,
      data: data,
      index: index,
      username,
    })
  }
};

const dwollaClear = () => {
  return dispatch => {
    dispatch({
      type: DWOLLA_CLEAR,
    })
  }
};

const createDwollaCustomer = (
  token, onboarding_token, index, customer_type, user_type, username, identity_id) => {

  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dwolla/create-customer")
      .use(authorize_onboarding(token, onboarding_token))
      .send({ index, customer_type, user_type, username, identity_id })
      .then(result => {
        resolve(result.body.data);
      });
  });
};

/**
 * Only set username if we're an admin loading dwolla for another user. Otherwise,
 * it gets the username from the viewer.
 */
const loadDwolla = (token, onboarding_token, username, index) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dwolla/get-state")
      .use(authorize_onboarding(token, onboarding_token))
      .send({ username, index })
      .then(result => {
        resolve(result.body.data.dwolla);
      });
  })
};

const refreshDwolla = (index, username) => {
  return (dispatch, getState) => {
    dispatch({
      type: DWOLLA_SET_LOADING,
      loading: true,
      index,
      username,
    })
    dispatch({
      type: REFRESH_DWOLLA,
      payload: superagent
        .post("/api/dwolla/get-state")
        .send({ index, username })
        .use(authorize_onboarding(
          getState().user.token,
          getState().user.onboarding_token))
    });
  }
};

// This is not used
const verifyDwollaCustomer = () => {
  return (dispatch, getState) => {
    dispatch({
      type: DWOLLA_SET_LOADING,
      loading: true,
    });
    dispatch({
      type: DWOLLA_VERIFY_CUSTOMER,
      payload: superagent
        .post("/api/dwolla/verify-customer")
        .use(authorize_onboarding(
          getState().user.token,
          getState().user.onboarding_token))
    })
  }
};

const setLoading = (index, loading) => {
  return dispatch => {
    dispatch({
      type: DWOLLA_SET_LOADING,
      loading: loading,
      index: index,
    })
  }
};

const mxMemberToFundingSource = (token, onboarding_token, member_guid, user_guid) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dwolla/mx-member-to-funding-source")
      .send({ member_guid, user_guid })
      .use(authorize_onboarding(token, onboarding_token))
      .then(result => {
        if (result.body.ok) {
          return resolve(result.body.data);
        }
        return reject(result.body);
      })
  });
}

const getMXConnect = (token, onboarding_token, redirect_url) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dwolla/get-mx-connect")
      .send({ redirect_url })
      .use(authorize_onboarding(token, onboarding_token))
      .then(result => {
        return resolve(result.body.data);
      })
  })
}

const UpdateFundingSource = (token, onboarding_token, funding_source_id, set_default, metadata = {}) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dwolla/update-funding-source")
      .send({ funding_source_id, set_default, metadata })
      .use(authorize_onboarding(token, onboarding_token))
      .then(result => {
        resolve(result.body.data);
      })
  })
};

const SetFundingSourceDefault = (token, onboarding_token, funding_source_id) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dwolla/set-funding-source-default")
      .send({ funding_source_id })
      .use(authorize_onboarding(token, onboarding_token))
      .then(result => {
        resolve(result.body.data);
      })
  })
};

const RemoveFundingSource = (token, onboarding_token, funding_source_id) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dwolla/remove-funding-source")
      .send( { funding_source_id })
      .use(authorize_onboarding(token, onboarding_token))
      .then(result => {
        return resolve(result.body.data);
      })
  })
}

const InitiateMicroPayments = (
  token, onboarding_token, routing_number, account_number, account_type, name) => {

  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dwolla/initiate-micropayments")
      .send({ routing_number, account_number, account_type, name })
      .use(authorize_onboarding(token, onboarding_token))
      .then(result => {
        resolve(result.body.data);
      })
  });
};

const VerifyMicroPayments = (
  token, onboarding_token, payment_source_id, amt_0_cents, amt_1_cents) => {

  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dwolla/verify-micropayments")
      .send({ payment_source_id, amt_0_cents, amt_1_cents})
      .use(authorize_onboarding(token, onboarding_token))
      .then(result => {
        resolve(result.body.data);
      })
  })
};

const setContributionRequest = (
  token, set_contribution, cadence, amt_usd, index, username) => {

  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dwolla/set-payment-contribution")
      .use(authorize(token))
      .send({ set_contribution, cadence, amt_usd, index, username })
      .then(result => {
        if (result.body.status === "ERROR") {
          console.log("Error", result.body);
        }
        return resolve();
      });
  })
}

const PaymentRequest = (
  token, onboarding_token, username_from, acct_from,
  username_to, acct_to, amt_cents, future_date,
  multi_leg_dest, is_funding_payment) => {

  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dwolla/initiate-payment-request")
      .use(authorize_onboarding(token, onboarding_token))
      .send({ username_from, acct_from,
        username_to, acct_to, amt_cents, future_date,
        multi_leg_dest, is_funding_payment })
      .then(result => {
        if (result.body.ok) {
          return resolve(result.body.data);
        }
        return reject(result.body.error);
      })
  })
}

const dwollaReducer = (state = {}, action) => {
  let dwolla = null;
  let key = null;
  let index = null;
  let username;
  if ("index" in action) {
    index = action.index;
    key = sprintf("%04d", index);
  }
  const new_state = deep_copy(state);

  switch(action.type) {
    case DWOLLA_UPDATE:
      if (action.index === -1) {
        // replace the entire thing
        return {
          ...state,
          ...action.data,
        };
      } else if (action.username) {
        const result = deep_copy(state);
        deep_update(result, [action.username, key], action.data);
        return result;
      } else {
        const result = deep_copy(state);
        deep_update(result, [key], action.data);
        return result;
      }
    case REFRESH_DWOLLA + "_FULFILLED":
      dwolla = action.payload.body.data.dwolla;
      index = action.payload.body.data.index;
      key = sprintf("%04d", index);
      username = action.payload.body.data.username;
      if (username) {
        deep_update(new_state, [username, key], dwolla);
      } else {
        deep_update(new_state, [key], dwolla);
      }
      deep_update(new_state, [], { loading: false });
      return new_state;
    case DWOLLA_VERIFY_CUSTOMER + "_FULFILLED":
      dwolla = action.payload.body.data.dwolla;
      index = action.payload.body.data.index;
      key = sprintf("%04d", index);
      return {
        ...state,
        [key]: {
          ...state[key],
          ...dwolla,
          loading: false,
        }
      };
    case DWOLLA_SET_LOADING:
      deep_update(new_state, [], { loading: action.loading});
      return new_state;
    case DWOLLA_CLEAR:
      return {};
    default:
      return state;
  }
};

export { dwollaReducer, dwollaUpdate, createDwollaCustomer, DWOLLA_UPDATE,
  verifyDwollaCustomer, setLoading, refreshDwolla,
  UpdateFundingSource, InitiateMicroPayments,
  VerifyMicroPayments, loadDwolla, RemoveFundingSource, SetFundingSourceDefault,
  dwollaClear, getMXConnect, mxMemberToFundingSource,
  PaymentRequest, setContributionRequest };
